import { setC4 } from "@thi.ng/vectors";
import { INV8BIT } from "./constants";
export const int32Rgba = (out, src) => {
    src = typeof src === "number" ? src : src.deref();
    return setC4(out || [], ((src >>> 16) & 0xff) * INV8BIT, ((src >>> 8) & 0xff) * INV8BIT, (src & 0xff) * INV8BIT, ((src >>> 24) & 0xff) * INV8BIT);
};
export const int24Rgba = (out, src) => {
    src = typeof src === "number" ? src : src.deref();
    return int32Rgba(out, src | 0xff000000);
};
